"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.markDropdownItemsAsParent = exports.getMaxHeight = exports.dropdownHasSubmenus = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/ends-with"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _react = _interopRequireWildcard(require("react"));

var _DropdownItem = _interopRequireDefault(require("reactstrap/lib/DropdownItem"));

var _DropdownMenu = _interopRequireDefault(require("reactstrap/lib/DropdownMenu"));

var _utils = require("./utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context6, _context7; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context6 = ownKeys(Object(source), !0)).call(_context6, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context7 = ownKeys(Object(source))).call(_context7, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var dropdownHasSubmenus = function dropdownHasSubmenus(items) {
  var _context;

  return (0, _some["default"])(_context = items || []).call(_context, function (item) {
    var _context2;

    return !item.heading && (0, _utils.hasProperty)(item, "items") || item.heading && (0, _some["default"])(_context2 = item.items || []).call(_context2, function (i) {
      return (0, _utils.hasProperty)(i, "items");
    });
  });
};

exports.dropdownHasSubmenus = dropdownHasSubmenus;

var markDropdownItemsAsParent = function markDropdownItemsAsParent() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _map["default"])(items).call(items, function (item) {
    if (!item.heading && (0, _utils.hasProperty)(item, "items")) {
      item.isParent = true;
    } else if (item.heading && item.items) {
      item.items = markDropdownItemsAsParent(item.items);
    }

    return item;
  });
};

exports.markDropdownItemsAsParent = markDropdownItemsAsParent;

var getMaxHeight = function getMaxHeight(props) {
  var _context3;

  return (0, _endsWith["default"])(_context3 = String(props.maxMenuHeight)).call(_context3, "px") ? props.maxMenuHeight : "".concat(props.maxMenuHeight, "px");
};

exports.getMaxHeight = getMaxHeight;
var DropdownUtils = /*#__PURE__*/(0, _createClass2["default"])(function DropdownUtils(hasSubmenus) {
  var _this = this;

  (0, _classCallCheck2["default"])(this, DropdownUtils);
  (0, _defineProperty2["default"])(this, "renderDropdownItems", function (props) {
    var itemsWithParent = markDropdownItemsAsParent(props.items);
    return (0, _map["default"])(itemsWithParent).call(itemsWithParent, function (item, index) {
      if ((0, _utils.hasProperty)(item, "divider")) {
        return _this.renderDivider(index);
      }

      if ((0, _utils.hasProperty)(item, "heading")) {
        return _this.renderHeadingItems(props, item, index);
      }

      return _this.renderItem(props, item, index);
    });
  });
  (0, _defineProperty2["default"])(this, "renderDivider", function (index) {
    return /*#__PURE__*/_react["default"].createElement(_DropdownItem["default"], {
      divider: true,
      key: index
    });
  });
  (0, _defineProperty2["default"])(this, "renderItem", function (props, item, index) {
    var href = item.href,
        target = item.target;
    var linkProps = {};

    if (href) {
      linkProps.href = href;

      if (target) {
        linkProps.target = target;
      }
    }

    return (0, _utils.isFunction)(item.renderComponent) ? item.renderComponent(item, index, null, "oui-dropdown-item") : /*#__PURE__*/_react["default"].createElement(_DropdownItem["default"], (0, _extends2["default"])({
      tag: item.isParent ? "li" : "button",
      key: index
    }, (0, _utils.gatherConditionalProps)(item, "disabled", "onClick"), {
      active: item.isActive
    }, linkProps, {
      onClick: !item.isParent ? function (e) {
        if ((0, _utils.isFunction)(props.onItemClick)) {
          props.onItemClick(item, e);
        }
      } : null,
      className: item.isParent ? "oui-dropdown-item-parent" : ""
    }), (0, _utils.isFunction)(item.label) ? item.label(item) : item.label, item.isParent ? /*#__PURE__*/_react["default"].createElement(_DropdownMenu["default"], {
      className: "oui-dropdown-submenu",
      tag: "ul",
      style: !dropdownHasSubmenus(item.items) ? {
        maxHeight: getMaxHeight(props),
        overflowY: "auto"
      } : {
        overflow: "visible",
        maxHeight: "none"
      }
    }, _this.renderDropdownItems(_objectSpread(_objectSpread({}, props), {}, {
      items: item.items
    }))) : null);
  });
  (0, _defineProperty2["default"])(this, "renderHeadingItems", function (props, headingItem, index) {
    var _context4;

    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: "fg-".concat(index)
    }, /*#__PURE__*/_react["default"].createElement(_DropdownItem["default"], {
      header: true,
      key: "header-".concat(index)
    }, headingItem.heading), (0, _map["default"])(_context4 = headingItem.items).call(_context4, function (item, ind) {
      var _context5;

      return _this.renderItem(props, item, (0, _concat["default"])(_context5 = "header-".concat(index, "-")).call(_context5, ind));
    }));
  });
  this.hasSubmenus = hasSubmenus;
});
exports["default"] = DropdownUtils;